import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useUpdateSettings = (key: string) => {
  const { call } = useApiPrivateRequest<void>();
  const updateSettings = async (value: string) => {
    await call("/user/settings", "PUT", undefined, [{ key, value }]);
  };
  return { updateSettings };
};
